/**
 *
 * MeasurementSelectRecipientTable
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { filter, flatMap, uniq, get } from "lodash"
import { Table, Input } from "antd"
import TruncateTextTooltip from "components/TruncateTextTooltip"
import ModalCustom from "../ModalCustom"
import { columns } from "./columns"
import "./index.less"
import { SearchOutlined } from "@ant-design/icons"

const columnsCollaborators = [
  {
    title: "Nombre",
    dataIndex: "first_name",
    key: "first_name",
  },
  {
    title: "Apellido",
    dataIndex: "last_name",
    key: "last_name",
  },
  {
    title: "Puesto",
    dataIndex: "position_name",
    key: "position_name",
    render: (text) => <TruncateTextTooltip title={text} />,
  },
]

/* eslint-disable react/prefer-stateless-function */
class MeasurementSelectRecipientTable extends React.Component {
  state = {
    modalOpenReceiver: false,
    divisionEmployeesSelected: [],
    divisionSelected: {},
    inputCollaboratorsSearch: "",
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
  }

  filterCollaborators = () => {
    const { inputCollaboratorsSearch } = this.state
    if (inputCollaboratorsSearch) {
      return filter(this.state.divisionEmployeesSelected, (item) =>
        item.full_name
          .toLowerCase()
          .includes(inputCollaboratorsSearch.toLowerCase())
      )
    }

    return this.state.divisionEmployeesSelected
  }

  render() {
    if (!this.props.dataSource) {
      return null
    }
    if (this.props.dataSource.length === 0) {
      return null
    }
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {},
      onSelect: (record, selected, selectedRows) => {
        if (selected) {
          return this.props.getDescendantsWatcher(record.id_division)
        }

        this.props.deselectRows(record.id_division, record)
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        if (selected) {
          const divisionsFlatMap = flatMap(selectedRows, (item) => item)
          const divisionIds = flatMap(
            divisionsFlatMap,
            (item) => item.id_division
          )

          return this.props.setStateFrom("descendentsAll", divisionIds)
        }

        this.props.setStateFrom("divisionsRemoveSelectedAll", [])
      },
      selectedRowKeys: this.props.stateSelectedRows,
    }

    const rowSelectionModal = {
      onChange: (selectedRowKeys, selectedRows) => {
        const newSelectedEmployees = [...this.props.employeesSelected]
        const previousEmployees = this.state.divisionEmployeesSelected.map(
          (item) => item.id_employee
        )
        const toDelete = new Set(previousEmployees)
        const newArray = newSelectedEmployees.filter(
          (item) => !toDelete.has(item)
        )
        const finalSelectedEmployees = uniq(newArray.concat(selectedRowKeys))
        this.props.setStateFrom(
          "employeesSelected",
          finalSelectedEmployees,
          this.state.divisionSelected
        )
      },
      onSelect: (record, selected, selectedRows) => {},
      selectedRowKeys: this.props.employeesSelected,
    }

    return (
      <React.Fragment>
        <div className="total-recipients">
          Total de destinatarios:{" "}
          {this.props.employeesSelected
            ? uniq(this.props.employeesSelected).length
            : 0}
        </div>
        <Table
          rowSelection={rowSelection}
          bordered
          rowClassName={(record) => {
            const employeesFlatMap = flatMap(
              record.employees,
              (item) => item.id_employee
            )
            const itsAllItems = uniq(
              filter(this.props.employeesSelected, (item) =>
                employeesFlatMap.includes(item)
              )
            )

            if (
              employeesFlatMap.length !== itsAllItems.length &&
              itsAllItems.length !== 0
            ) {
              return record.children.length
                ? "no-select-all-items"
                : "hasnochildren no-select-all-items"
            }

            return record.children.length ? "" : "hasnochildren"
          }}
          rowKey={(record) => record.id_division}
          className="measurement-select-recipient-table"
          expandedRowKeys={this.props.descendents}
          expandIconColumnIndex={6}
          onExpandedRowsChange={(openRows) => {
            this.props.openRows(openRows)
          }}
          // onExpand={(expanded, record) => {}}
          loading={this.props.isLoadingDescendents}
          dataSource={this.props.dataSource}
          columns={columns(this.setStateFrom, this.props.employeesSelected)}
          pagination={false}
        />

        <ModalCustom
          width={648}
          showOnlyCancel
          textCancelButton="Cerrar"
          title={`Editar destinatarios de ${get(
            this.state,
            "divisionSelected.name",
            ""
          )}`}
          modalOpen={this.state.modalOpenReceiver}
          onCancel={() => {
            this.setState({ modalOpenReceiver: false })
          }}>
          <div className="edit-recipient-modal-header">
            <Input
              suffix={<SearchOutlined type="search" />}
              placeholder="Buscar..."
              onChange={(e) =>
                this.setStateFrom("inputCollaboratorsSearch", e.target.value)
              }
            />
            <span>
              {this.state.divisionEmployeesSelected.length} colaboradores
            </span>
          </div>
          <Table
            rowSelection={rowSelectionModal}
            bordered
            className="edit-recipient-modal-table"
            rowKey={(record) => record.id_employee}
            dataSource={this.filterCollaborators()}
            columns={columnsCollaborators}
            pagination={{
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 15,
            }}
          />
        </ModalCustom>
      </React.Fragment>
    )
  }
}

MeasurementSelectRecipientTable.propTypes = {}

export default MeasurementSelectRecipientTable
